/**
 * 状态栏提供器
 */

import { tools } from '../utils/tools.js';
import { element } from '../utils/element.js';

import { EventEmitter } from '../EventEmitter.js';
export default class StatusBar extends EventEmitter {
    constructor(proc) {
        super();
        this.proc = proc;
        this.$root = proc.$root;
        this.isLogined = proc.data.isLogined;
        this.$Application = proc.make('Application');
        this.init();
    }
    apps = [];
    activeApps = [];

    init() {
        this.$Application.on('application.run', () => {
            this.apps = this.$Application.getApps();
            Object.keys(this.apps).forEach(key => {
                if (this.apps[key].matedata.category !== 'system' && this.apps[key].app.active) {
                    this.activeApps.push(this.apps[key].app);
                }
            })
        })
        this.$Application.receiveMsg(this.getReceiveMsg.bind(this))
    }

    getReceiveMsg(val){
        console.log('receive msg', val);
    }

    // 获取时间日期
    getTime() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();
        let second = date.getSeconds();
        return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}:${second < 10 ? '0' + second : second}`;
    }
}